"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

require("./Error.scss");

var _500_png_1 = __importDefault(require("../assets/images/500.png"));

var ErrorPage = function ErrorPage(_a) {
  var children = _a.children;
  return react_1.default.createElement("main", {
    className: "page",
    style: {
      backgroundImage: "url(" + _500_png_1.default + ")"
    }
  }, react_1.default.createElement("details", null, react_1.default.createElement("summary", null, "Details"), children), react_1.default.createElement("a", {
    href: "/",
    className: "link"
  }, "Back to home"));
};

exports.default = ErrorPage;